import React, { useState, useEffect } from 'react';
import { render } from '@react-email/render';
import { axios } from "lib/axios";
import { Button } from '@mui/material';
import { Section } from '@react-email/components';
import { EmailHtml, EmailHead, EmailHeader, EmailFooter, JobAdBody, WeeklyBlogBody, JobAdBodyHeader, JobAdBodyFooter, JobAdItem, MEMBERSHIP_LINK_QUERY, BlogPostHeader, WeeklyBlogBodyFooter, BlogPostItem } from '../components/email/EmailTemplate';
import RenderReactEmail from '../components/email/RenderReactEmail';

const EmailTemplatePreview = () => {
  const [headHtml, setHeadHtml] = useState('');
  const [headerHtml, setHeaderHtml] = useState('');
  const [footerHtml, setFooterHtml] = useState('');
  const [jobAdBodyHtml, setJobAdBodyHtml] = useState('');
  const [weeklyNewsletterHtml, setWeeklyNewsletterHtml] = useState('');

  useEffect(() => {
    const generateTemplates = async () => {
        // Render static components
        setHeadHtml(await render(<EmailHead />));
        setHeaderHtml(await render(<EmailHeader />));
        setFooterHtml(await render(<EmailFooter />));
        
        // Render spacer components
        const headerSpacerHtml = await render(<div style={{ height: '48px' }} />);
        const itemSpacerHtml = await render(<div style={{ height: '22px' }} />);

        // --- Generate Daily Newsletter Body ---
        const jobAdPlaceholder = {
            BuyerLogoURL: '{{.BuyerLogoURL}}',
            Role: '{{.Role}}',
            BuyerName: '{{.BuyerName}}',
            Slug: '{{.Slug}}',
        };
        const jobAdItemHtml = await render(<JobAdItem jobAd={jobAdPlaceholder} linkQuery={MEMBERSHIP_LINK_QUERY} />);
        const jobAdHeaderHtml = await render(<JobAdBodyHeader />);
        const jobAdFooterHtml = await render(<JobAdBodyFooter linkQuery={MEMBERSHIP_LINK_QUERY} />);
        const dailyBodyContent = `${jobAdHeaderHtml}${headerSpacerHtml}{{range .JobAds}}${jobAdItemHtml}${itemSpacerHtml}{{end}}${headerSpacerHtml}${jobAdFooterHtml}`;
        const dailyWrapperHtml = await render(
            <Section className="body-section" style={{ padding: '57px 71px', backgroundColor: '#FFF' }}>__BODY_CONTENT_PLACEHOLDER__</Section>
        );
        const finalJobAdBody = dailyWrapperHtml.replace('__BODY_CONTENT_PLACEHOLDER__', dailyBodyContent);
        setJobAdBodyHtml(finalJobAdBody);

        // --- Generate Weekly Newsletter Body ---
        const blogPostPlaceholder = {
            PictureURL: '{{.Blog.PictureURL}}',
            Title: '{{.Blog.Title}}',
            Description: '{{truncate .Blog.Description 100}}',
            CreatorName: '{{.Blog.Creator.Name}}',
            CreatorLogoURL: '{{.Blog.Creator.SquareLogoURL}}',
            Slug: '{{.Blog.Slug}}',
        };
        const blogPostItemHtml = await render(<BlogPostItem post={blogPostPlaceholder} />);

        const blogPostHeaderHtml = await render(<BlogPostHeader />);
        const blogPostFooterHtml = await render(<WeeklyBlogBodyFooter />);

        console.log(
          "Rimini.user.current_organisation.id",
          blogPostPlaceholder,
        );

        const blogRowsHtml = `
            {{range .BlogRows}}
                <div class="blog-row" style="margin-bottom: 22px; font-size: 0; text-align: left;">
                    {{range .Items}}
                        {{if .Blog}}
                            <div class="blog-post-wrapper" style="width: 31.33%; display: inline-block; vertical-align: top; text-align: left; font-size: 14px; box-sizing: border-box; border: 1px solid #F2F2F2; border-radius: 8px; background-color: #FFF; box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.04); margin-right: {{if .HasSpacer}}2.5%{{else}}0{{end}};">
                                ${blogPostItemHtml}
                            </div>
                        {{end}}
                    {{end}}
                </div>
            {{end}}
        `;

        const weeklyBodyContent = `
            ${blogPostHeaderHtml}
            <div style="height: 48px"></div>
            <div style="margin: 0 auto; max-width: 750px;">
                ${blogRowsHtml}
            </div>
            <div style="height: 48px"></div>
            ${blogPostFooterHtml}
        `;

        const weeklyWrapperHtml = await render(
            <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" className="body-section" style={{ padding: '57px 71px', backgroundColor: '#FFF' }}>
                <tbody>
                    <tr>
                        <td>__BODY_CONTENT_PLACEHOLDER__</td>
                    </tr>
                </tbody>
            </table>
        );
        const finalWeeklyBody = weeklyWrapperHtml.replace('__BODY_CONTENT_PLACEHOLDER__', weeklyBodyContent);
        setWeeklyNewsletterHtml(finalWeeklyBody);
    }
    generateTemplates();
  }, []);

  const handleSave = async () => {
    try {
      const headPayload = { name: 'default-head', type: 'head', content: headHtml };
      const headerPayload = { name: 'default-header', type: 'header', content: headerHtml };
      const footerPayload = { name: 'default-footer', type: 'footer', content: footerHtml };
      const jobAdBodyPayload = { name: 'daily-newsletter-body', type: 'body', content: jobAdBodyHtml };
      const weeklyNewsPayload = { name: 'weekly-newsletter-body', type: 'body', content: weeklyNewsletterHtml };

      await Promise.all([
        axios.post('/api/newsletter/components', headPayload),
        axios.post('/api/newsletter/components', headerPayload),
        axios.post('/api/newsletter/components', footerPayload),
        axios.post('/api/newsletter/components', jobAdBodyPayload),
        axios.post('/api/newsletter/components', weeklyNewsPayload),
      ]);

      alert('All templates saved successfully!');
    } catch (error) {
      console.error('Error saving templates:', error);
      alert('Failed to save templates. Check the console for details.');
    }
  };

  const mockJobAds = [
    {
        BuyerLogoURL: 'http://localhost:3000/images/square_logo.png',
        BuyerName: 'City of Stockholm',
        Role: 'Senior System Architect',
        Slug: 'senior-system-architect-123',
    },
    {
        BuyerLogoURL: 'http://localhost:3000/images/square_logo.png',
        BuyerName: 'Delegon AB',
        Role: 'Lead Frontend Developer',
        Slug: 'lead-frontend-dev-456',
    }
  ];

  const mockBlogPosts = [
    {
        PictureURL: 'http://localhost:3000/images/Blog.png',
        Title: 'The Future of Public Tenders in Sweden',
        CreatorName: 'John Doe',
        Description: 'A deep dive into the changing landscape of public procurement and what it means for suppliers.',
        Slug: 'future-of-tenders-123',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png',
    },
    {
        PictureURL: 'http://localhost:3000/images/Blog2.png',
        Title: 'Top 5 AI Tools for Market Analysis',
        CreatorName: 'Jane Smith',
        Description: 'Discover the best AI-powered tools that can give you a competitive edge in market analysis.',
        Slug: 'top-5-ai-tools-456',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png'
    },
    {
        PictureURL: 'http://localhost:3000/images/Blog.png',
        Title: 'A Guide to Sustainable Business Practices',
        CreatorName: 'Peter Jones',
        Description: 'Learn how to implement sustainable practices in your business for a better future. Learn how to implement sustainable practices in your business for a better future.',
        Slug: 'sustainable-business-789',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png'
    },
    {
        PictureURL: 'http://localhost:3000/images/Blog.png',
        Title: 'Navigating the Complexities of GDPR',
        CreatorName: 'Susan White',
        Description: 'A comprehensive guide to ensure your business is fully compliant with GDPR regulations.',
        Slug: 'gdpr-compliance-101',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png'
    },
  ];

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', width: '100%', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Email Template Preview</h1>
        <Button variant="contained" onClick={handleSave}>
          Save All Templates
        </Button>
      </div>
      <p>This page provides a visual preview of all email components and saves their generated HTML templates.</p>

      <section style={{ marginBottom: '40px' }}>
        <h2>Head</h2>
        <details>
            <summary>Template String</summary>
            <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', border: '1px solid #ccc', padding: '10px' }}>
                {headHtml}
            </pre>
        </details>
      </section>
      
      <hr style={{ margin: '40px 0' }} />

      <section style={{ marginBottom: '40px' }}>
        <h2>Header</h2>
        <div style={{ border: '1px solid #ccc' }}>
          <RenderReactEmail component={<EmailHtml><EmailHeader /></EmailHtml>} />
        </div>
        <details>
            <summary>Template String</summary>
            <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', border: '1px solid #ccc', padding: '10px' }}>
                {headerHtml}
            </pre>
        </details>
      </section>

      <hr style={{ margin: '40px 0' }} />

      <section style={{ marginBottom: '40px' }}>
        <h2>Job Ad Newsletter Body</h2>
        <div style={{ border: '1px solid #ccc'}}>
          <RenderReactEmail component={<EmailHtml><JobAdBody jobAds={mockJobAds} /></EmailHtml>} />
        </div>
        <details>
            <summary>Template String</summary>
            <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', border: '1px solid #ccc', padding: '10px' }}>
                {jobAdBodyHtml}
            </pre>
        </details>
      </section>

      <hr style={{ margin: '40px 0' }} />

      <section style={{ marginBottom: '40px' }}>
        <h2>Weekly Newsletter Body</h2>
        <div style={{ border: '1px solid #ccc'}}>
           <RenderReactEmail component={<EmailHtml><WeeklyBlogBody blogPosts={mockBlogPosts} /></EmailHtml>} />
        </div>
        <details>
            <summary>Template String</summary>
            <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', border: '1px solid #ccc', padding: '10px' }}>
                {weeklyNewsletterHtml}
            </pre>
        </details>
      </section>

      <hr style={{ margin: '40px 0' }} />

      <section>
        <h2>Footer</h2>
        <div style={{ border: '1px solid #ccc' }}>
          <RenderReactEmail component={<EmailHtml><EmailFooter /></EmailHtml>} />
        </div>
        <details>
            <summary>Template String</summary>
            <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', border: '1px solid #ccc', padding: '10px' }}>
                {footerHtml}
            </pre>
        </details>
      </section>
    </div>
  );
};

export default EmailTemplatePreview;
